import { TranslateResult } from 'vue-i18n';

/**
 * Get the localized promotion title, with special handling for Volume Light
 * @param promotionType The promotion type (e.g., 'volume', 'basic', 'boost')
 * @param $t The Vue i18n $t translate function
 * @param volumePackageIsLight flag to indicate if the volume package is light variant
 * @returns Localized promotion title
 */
export const getPromotionTitle = (
  promotionType: string,
  $t: (key: string) => TranslateResult,
  volumePackageIsLight?: boolean
): TranslateResult => {
  if (promotionType === 'volume' && volumePackageIsLight) {
    return $t('general.promotion.title.volume_light');
  }
  return $t(`general.promotion.title.${promotionType}`);
};
